<template>
<!-- Confirm modal: modal.detail: content, leftText, rightText, leftAction, rightAction -->
    <vue-modal
        v-model="modal.isVisible"
        :header="false"
        :modalBodyClass="$prefixClass.modal + '-confirm'"
    >
        <div class="text-center">
            <p v-html="modal.content"></p>
        </div>

        <div class="text-center" slot="footer">
            <a-button type="default" @click="leftFunc">{{modal.cancelText ? modal.cancelText : 'Cancel'}}</a-button>
            <a-button type="primary" @click="rightFunc">{{modal.okText ? modal.okText : 'OK'}}</a-button>
        </div>
    </vue-modal>
</template>
<script>
export default {
    name: 'VueModalConfirm',
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        modal: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit(this.value)
            }
        }
    },
    created() {
    },
    methods: {
        leftFunc() { 
            this.modal.isVisible = false;
            this.$emit(this.modal.leftAction ? this.modal.leftAction : 'onCancel');
        },

        rightFunc() {
            this.modal.isVisible = false;
            this.$emit(this.modal.rightAction ? this.modal.rightAction : 'doAction');
        }
    }
}
</script>
<style lang="scss">
    .#{$modal}-confirm {
        width: 420px !important;
        .#{$modal} {
            &-body {
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 133px;
                p {
                    margin-bottom: 0;
                }
            }
            &-footer {
                padding: 16px;
            }
        }
    }
</style>